import { memo } from 'react';
import { useSelector } from 'react-redux';
import { FetchableRecruitmentProfilePreview } from './RecruitmentProfilePreview/FetchableRecruitmentProfilePreview';
import { ComplexTooltip } from '../../../../../../../shared/frontend/components/presentational/tooltip';
import { Link } from '../../../../../../../shared/frontend/components/link';
import { featuresSelector } from '../../../../../../../shared/frontend/scripts/selectors/global';

type TRecruitmentProfileBadge = {
  className?: string;
  size?: string;
  profile: number;
  link?: string;
};

function RecruitmentProfileBadgeBase(props: TRecruitmentProfileBadge) {
  const currentFeatures = useSelector(featuresSelector);
  if (!currentFeatures.recruitment_view) {
    return null;
  }

  const size = props.size || 'small';

  const badgeWithTooltip = (
    <ComplexTooltip
      placement="top"
      tag="span"
      tooltip={<FetchableRecruitmentProfilePreview profileId={props.profile} />}
      className={`rec-badge rec-badge--${size} rio-text-shadow--normal`}
      overlayStyle={{ opacity: 1 }}
      mouseLeaveDelay={0.3}
    >
      <i className="fa fa-id-card-alt" />
    </ComplexTooltip>
  );

  return props.link ? (
    <Link to={props.link} className={props.className}>
      {badgeWithTooltip}
    </Link>
  ) : (
    <span className={props.className}>{badgeWithTooltip}</span>
  );
}

const check = (p: TRecruitmentProfileBadge, n: TRecruitmentProfileBadge) => p.profile === n.profile;
export const RecruitmentProfileBadge = memo(RecruitmentProfileBadgeBase, check);
